import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { ICommendaOnboarding } from './types';

export function useSalesTaxOnboarding({
  corporationId,
  token = undefined,
}: {
  corporationId: string | number;
  token?: string | undefined;
}) {
  const { data, error, isLoading, mutate } = useSWR<ICommendaOnboarding>(
    corporationId
      ? `new-sales-tax/onboarding/corporation/${corporationId}`
      : null,
    SWRFetcher(
      {
        method: 'GET',
      },
      token
    )
  );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
}
